import axios from './HTTP'

export default {
  getAll (callback) {
    axios
      .get('/api/skills.json')
      .then(response => ( callback(response.data) ))
  },
  create (params, callback) {
    axios
      .post('/api/skills.json', {
        name: params.name,
        global: params.global,
        user_id: params.user_id
      })
      .then(response => ( callback(response.data) ))
  },
  destroy (id, callback) {
    axios
      .delete(`/api/skills/${ id }.json`)
      .then(response => ( callback(response.data) ))
  },
}
